"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextualMenu = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var ContextualMenu_base_1 = require("./ContextualMenu.base");
var ContextualMenu_styles_1 = require("./ContextualMenu.styles");
function onRenderSubMenu(subMenuProps) {
    return React.createElement(LocalContextualMenu, tslib_1.__assign({}, subMenuProps));
}
// This is to prevent cyclic import with ContextualMenu.base.tsx.
var LocalContextualMenu = (0, Utilities_1.styled)(ContextualMenu_base_1.ContextualMenuBase, ContextualMenu_styles_1.getStyles, function (props) { return ({
    onRenderSubMenu: props.onRenderSubMenu
        ? (0, Utilities_1.composeRenderFunction)(props.onRenderSubMenu, onRenderSubMenu)
        : onRenderSubMenu,
}); }, { scope: 'ContextualMenu' });
/**
 * ContextualMenu description
 */
exports.ContextualMenu = LocalContextualMenu;
exports.ContextualMenu.displayName = 'ContextualMenu';
//# sourceMappingURL=ContextualMenu.js.map